import { render, staticRenderFns } from "./ServiceResponsibleBonuses.vue?vue&type=template&id=97353b8e&"
import script from "./ServiceResponsibleBonuses.vue?vue&type=script&lang=js&"
export * from "./ServiceResponsibleBonuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports